import React, { useEffect, useState } from "react";
import FormField from "../../components/ui/FormField";
import { INVOICE_CONFIG } from "../../config/invoiceConfig";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const InvoiceForm = ({ initialData, onSubmit, onCancel }) => {

  const [invoiceType, setInvoiceType] = useState(initialData?.type || "GOODS");
const navigate = useNavigate();
  const config = INVOICE_CONFIG[invoiceType];

  const [form, setForm] = useState({
    type: invoiceType,
    items: [{}],
    ...initialData
  });

  useEffect(() => {
    setForm({
      type: invoiceType,
      items: [{}],
      ...initialData
    });
  }, [invoiceType]);

  const handleChange = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const handleItemChange = (index, field, value) => {
    const updated = [...(form.items || [])];
    updated[index] = { ...updated[index], [field]: value };
    setForm({ ...form, items: updated });
  };

  const addItem = () => {
    setForm({ ...form, items: [...(form.items || []), {}] });
  };

  const removeItem = (index) => {
    const updated = [...form.items];
    updated.splice(index, 1);
    setForm({ ...form, items: updated });
  };

  const calculateTotal = () => {
    return (form.items || []).reduce((sum, item) => {
      const rate = Number(item.rate || 0);
      const qty = Number(item.qty || 1);
      const discount = Number(item.discount || 0);
      return sum + (rate * qty - discount);
    }, 0);
  };

  const handleSubmit = () => {
    const invoice = {
      ...form,
      id: form.id || `INV-${Date.now()}`,
      total: calculateTotal(),
      type: invoiceType,
    };
    onSubmit(invoice);
  };

  return (
    <div className="bg-white p-6 rounded shadow">
        <div className="flex flex-row justify-items-center">
       <div onClick={()=>navigate(-1)}><ArrowLeft className="h-5 w-5"/></div>
      <h2 className="text-xl font-semibold mb-4">{config.title}</h2>
</div>
      <div className="mb-6">
        <label className="text-sm font-medium block mb-1">Invoice Type</label>
        <select
          value={invoiceType}
          onChange={(e) => setInvoiceType(e.target.value)}
          className="w-full border px-3 py-2 rounded"
        >
          <option value="GOODS">Goods</option>
          <option value="SERVICES">Services</option>
          <option value="EXPORT">Export</option>
        </select>
      </div>

     

      {config?.headerFields?.length > 0 && (
        <div className="mt-4 border p-4 rounded">
          <h5 className="font-semibold mb-3">{config.title}</h5>

          <div className="grid grid-cols-3 md:grid-col-3 gap-4">
            {config.headerFields?.map((field) => (
              <FormField
                key={field.key}
                label={field.label}
                type={field.type}
                rows={field.rows}
                required={field.required}
                value={form[field.key] || ""}
                onChange={(v) => handleChange(field.key, v)}
              />
            ))}
          </div>
          
        </div>
      )}
      {config?.sections?.map((section, idx) => (
        <div key={idx} className="mt-4 border p-4 rounded">
          <h5 className="font-semibold mb-3">{section.sectionTitle}</h5>

          <div className="grid grid-cols-3 md:grid-col-3 gap-4">
            {section?.fields?.map((field) => (
              <FormField
                key={field.key}
                label={field.label}
                type={field.type}
                rows={field.rows}
                required={field.required}
                value={form[field.key] || ""}
                onChange={(v) => handleChange(field.key, v)}
              />
            ))}
          </div>
          
        </div>
      ))}

      {/* ================= ITEMS ================= */}
      <div className="mt-6">

        <h5 className="font-semibold mb-2">Items</h5>
        {(form.items || []).map((item, i) => (
          <div
          key={i}
          className="grid grid-cols-3 gap-3 mt-2 border p-3 rounded relative"
          >
            {config.itemFields.map((field) => (
              <FormField
                key={field.key}
                label={field.label}
                type={field.type}
                required={field.required}
                value={item[field.key] || ""}
                onChange={(v) => handleItemChange(i, field.key, v)}
              />
            ))}

            {form.items.length > 1 && (
              <button
                type="button"
                onClick={() => removeItem(i)}
                className="absolute top-2 right-2 text-red-500 text-xs"
              >
                ✕
              </button>
            )}
          </div>
        ))}

        <button
          onClick={addItem}
          className="mt-3 text-blue-600 text-sm"
        >
          + Add Item
        </button>
      </div>

      {/* ================= TOTAL ================= */}
      <div className="mt-4 font-semibold text-right">
        Total: ₹ {calculateTotal()}
      </div>

      {/* ================= ACTION BUTTONS ================= */}
      <div className="flex gap-3 mt-6">
        <button
          onClick={handleSubmit}
          className="bg-primary text-white px-4 py-2 rounded"
        >
          Save Invoice
        </button>
        <button
          onClick={onCancel}
          className="bg-primary text-white px-4 py-2 rounded"
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default InvoiceForm;